import { Modal, TextInput } from "flowbite-react";
import { DataTable } from "../../../components/data-table";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../actions";
import { FlatButton } from "../../../components/buttons";

export function AddAccountManager({
  readOnly,
  disabled,
  formik,
  title = "Update",
}) {
  const dispatch = useDispatch();
  const urlParams = useRef({});

  const coworkersList = useSelector((state) => state?.coworker?.list);

  const [modalState, setModalState] = useState();
  const [selected, setSelected] = useState();

  useEffect(() => {
    setSelected(formik.values.account_manager);
  }, [formik.values.account_manager]);

  const columns = [
    {
      name: "Employee Code",
      key: "coworker_code",
    },
    {
      name: "Name",
      key: "first_name",
      formatText: (cell, row) => {
        return `${cell || ""} ${row.last_name || ""}`;
      },
    },
    { name: "Email", key: "email" },
    { name: "Primary Phone", key: "primary_phone_number" },
    { name: "Designation", key: "designation" },
    { name: "Role", key: "role" },
    {
      name: "Status",
      key: "is_active",
      formatText: (isActive) => {
        return isActive ? "Active" : "Inactive";
      },
      processClassName: (isActive) =>
        isActive ? "text-green-500 font-medium" : "text-red-500 font-medium",
    },
  ];

  const handleFetch = async (params) => {
    if (params) {
      urlParams.current.page = params.page;
      urlParams.current.count = params.pageLimit;
      urlParams.current.sort_by = params.sortBy;
      urlParams.current.sort = params.sortDir;
      urlParams.current["filter.keyword"] = params.keyword;
    }
    dispatch(actions.GETCOWORKERS_REQ(urlParams.current));
  };

  return (
    <div>
      <label className="text-sm font-medium text-gray-900 dark:text-gray-300">
        Account Manager
      </label>
      <div className="mt-2 wrapper peer">
        <TextInput
          onClick={() => {
            !readOnly && !disabled && setModalState("pop-up");
          }}
          disabled={disabled}
          readOnly
          placeholder={
            formik.values.account_manager || !readOnly
              ? "Account Manager"
              : "----"
          }
          className={`${
            readOnly
              ? "[&_input]:border-none [&_input]:p-0 [&_input:focus]:border-none [&_input:focus]:ring-0"
              : "cursor-pointer"
          } [&_input]:bg-transparent`}
          type="text"
          value={formik.values.account_manager?.fullName || ""}
        />
      </div>
      <Modal
        dismissible
        show={modalState}
        className="[&>div>div]:p-3 [&>div>div]:pr-0"
        size="5xl"
        onClose={() => {
          setSelected(formik.values.account_manager);
          setModalState();
        }}
      >
        {/* <Modal.Header /> */}
        <Modal.Body className="px-2 py-0">
          <div className="min-h-50 [&>div]:p-0">
            <DataTable
              name={`${title} Account Manager`}
              columns={columns}
              layout="auto"
              indexField="coworker_uid"
              remote={true}
              handleFetch={handleFetch}
              data={coworkersList?.data}
              totalCount={coworkersList?.total_records}
              rowSelection={{
                enable: true,
                type: "selection",
                position: "end",
                multi: false,
                initial: selected,
                onRowSelect: ({ selectedRows }) => {
                  setSelected(selectedRows);
                },
              }}
              toolbar={{
                search: { enable: true },
                hideCount: true,
              }}
              footer={{
                paginator: { enable: true, limits: [10], placement: "start" },
                customActions: (
                  <div className=" justify-self-end flex flex-row gap-x-6">
                    <FlatButton
                      size="xl"
                      appearance="secondary"
                      id="cancel-button"
                      onClick={() => {
                        setSelected(formik.values.account_manager);
                        setModalState(undefined);
                      }}
                    >
                      Cancel
                    </FlatButton>
                    <FlatButton
                      size="xl"
                      disabled={!selected}
                      appearance="primary"
                      id="confirm-button"
                      onClick={() => {
                        formik.setFieldValue("account_manager", selected);
                        setModalState(undefined);
                      }}
                    >
                      Choose
                    </FlatButton>
                  </div>
                ),
              }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
